export default class {
  error_codes = {
    400: "Campo obrigatório omitido no payload",
    401: "Você não possui permissão para realizar esta operação",
    403: "Sessão expirada, faço log-in novamente",
    404: "Registro não encontrado",
    405: "Operação não aplicável a este registro",
    406: "Falha na validação do payload...verifique os dados informados",
    409: "Registro já existente",
    412: "Os dados não atendem aos requisitos desta operação",
    500: "Não foi possível atender a esta solicitação no momento......tente novamente em instantes",
    503: "Serviço temporáriamente indisponível...tente novamente em instantes",
    999: "Erro desconhecido"
  }

  constructor(custom_error_codes) {
    if (custom_error_codes && Object.keys(custom_error_codes).length > 0) {
      for (let code in custom_error_codes) {
        this.default[code] = custom_error_codes[code]
      }
    }
  }

  getErrorMessage(status_code) {
    if (status_code in this.error_codes) {
      return this.error_codes[status_code]
    } else {
      this.error_codes[999]
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/notification-service.js